import { Controller } from "@hotwired/stimulus";
import ColorCalc from "../models/color_calc";

export default class extends Controller {
  static values = { tagName: String };

  connect() {
    this.badges = new Map();
    this.media = window.matchMedia("(prefers-color-scheme: dark)");
    this.boundRender = () => this.render();
    this.media.addEventListener("change", this.boundRender);
    this.render();
  }

  disconnect() {
    if (this.media) {
      this.media.removeEventListener("change", this.boundRender);
    }
    this.removeBadges();
  }

  render() {
    this.removeBadges();
    this.element.querySelectorAll(this.tagNameValue).forEach((target) => {
      this.renderFor(target);
    });
  }

  renderFor(target) {
    const style = getComputedStyle(target);
    const fg = this.rgbToHex(style.color);
    const bg = this.rgbToHex(style.backgroundColor);
    const colorCalc = ColorCalc.get(fg);
    if (!colorCalc || !bg) {
      return;
    }
    const badge = document.createElement("span");
    badge.className = "contrast-badge";
    const ratio = colorCalc.contrastRatio(bg);
    badge.textContent = `${ratio} ${colorCalc.passAA(bg) ? "✅" : "❌"}`;
    target.appendChild(badge);
    this.badges.set(target, badge);
  }

  removeBadges() {
    this.badges.forEach((badge) => badge.remove());
    this.badges.clear();
  }

  rgbToHex(value) {
    const match = value.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!match) {
      return null;
    }
    const [, r, g, b] = match;
    return (
      "#" +
      [r, g, b]
        .map((n) => parseInt(n, 10).toString(16).padStart(2, "0"))
        .join("")
    );
  }
}
